import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import RLPricing from '../components/rl/RLPricing';

function PricingPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          💳 Pricing & Packages
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Pick a package tuned for your trading desk, with promos and trials built-in.
        </Typography>
      </Box>

      <RLPricing />
    </Container>
  );
}

export default PricingPage;

